import React from "react";
import "./preloader.style.css";

export const Preloader = () => {
  return (
    <div className="preloader">
      <div className="strip-1" />
      <div className="strip-2" />
      <div className="strip-3" />
      <div className="strip-4" />
      <div className="strip-5" />
    </div>
  );
};
